// 공간 내장 코드·표기 해석 — 저장소를 읽지 않는 순수 조각이라 데이터층·화면이 같이 쓴다(`codes.ts` 는 getRepo 를 물어 순환이 난다).

import { type CodeEntry, parseCodeEntries } from "./code-parse";

export const SPACE_BUILTIN: readonly CodeEntry[] = [
  { code: "LIVING", label: "거실", active: true },
  { code: "KITCHEN", label: "주방", active: true },
  { code: "BATH", label: "욕실", active: true },
  { code: "BEDROOM", label: "침실", active: true },
  { code: "ENTRANCE", label: "현관", active: true },
  { code: "BALCONY", label: "베란다", active: true },
  { code: "COMMON", label: "공통", active: true },
];

// `codes.space` 설정 원문 → 코드 표기 함수 — 설정 화면과 같은 parseCodeEntries 한 벌로 읽고 목록에 없는 코드는 null.
export const spaceLabelLookup = (raw: string | null | undefined): ((code: string) => string | null) => {
  const labels = new Map<string, string>(parseCodeEntries(SPACE_BUILTIN, raw).map((row) => [row.code, row.label]));
  return (code) => labels.get(code) ?? null;
};

// 화면 표기용 — 못 찾은 코드는 코드 그대로(고객에게 나가는 사본에는 spaceLabelLookup 을 쓴다).
export const spaceLabelsFrom = (raw: string | null | undefined): ((code: string) => string) => {
  const lookup = spaceLabelLookup(raw);
  return (code) => lookup(code) ?? code;
};
